import { memo } from 'react';
import { Badge } from './Badge.js';

export type SettingsStatusBadgeState =
  | 'Verified'
  | 'Connected'
  | 'Recommended'
  | 'Needs setup'
  | 'Inactive';

export interface SettingsStatusBadgeProps {
  readonly state: SettingsStatusBadgeState;
  readonly label?: string;
  readonly className?: string;
}

const STATE_TONE: Record<SettingsStatusBadgeState, 'success' | 'primary' | 'warn' | 'neutral'> = {
  Verified: 'success',
  /** Credentials saved (Údaje uloženy) — not Ověřeno / not done. */
  Connected: 'warn',
  Recommended: 'primary',
  'Needs setup': 'warn',
  Inactive: 'neutral',
};

export const SettingsStatusBadge = memo(
  ({ state, label, className = '' }: SettingsStatusBadgeProps): JSX.Element => (
    <Badge tone={STATE_TONE[state]} size="md" className={className}>
      {label ?? state}
    </Badge>
  )
);

SettingsStatusBadge.displayName = 'SettingsStatusBadge';
